import React from 'react';
import { useTranslation } from 'react-i18next';

const InstallmentYearsPill = ({ years }: { years: number }) => {
  const { t } = useTranslation('app');

  return (
    <span className="text-caption-2 md:text-caption-1 text-center text-gray__dark_2 bg-gray rounded px-2 py-1 w-[88px]">
      {years} {years === 1 ? t('year') : t('years')}
    </span>
  );
};

export default InstallmentYearsPill;
